import { useEffect, useState, useCallback } from "react";
import { toast } from "react-toastify";

import { contactService } from "../../../services/contactService";

import {
    CONTACT_FILTER_INITIAL,
    CONTACT_PAGE_SIZE,
} from "../../../constants/admin/contact/contactConstants";

export const useContactManagement = () => {
    const [contacts, setContacts] = useState([]);

    const [loading, setLoading] = useState(false);

    const [page, setPage] = useState(1);

    const [totalPages, setTotalPages] = useState(1);

    const [filters, setFilters] = useState(
        CONTACT_FILTER_INITIAL
    );

    const fetchContacts = useCallback(async () => {
        setLoading(true);

        try {
            const params = {
                page,
                limit: CONTACT_PAGE_SIZE,
                ...Object.fromEntries(
                    Object.entries(filters).filter(
                        ([_, value]) => value
                    )
                ),
            };

            const res = await contactService.getAll(
                params
            );

            setContacts(res.data.data || []);
            setTotalPages(res.data.totalPages || 1);
        } catch (error) {
            console.error(error);
            toast.error("Lỗi tải danh sách liên hệ");
        } finally {
            setLoading(false);
        }
    }, [page, filters]);

    useEffect(() => {
        fetchContacts();
    }, [fetchContacts]);

    const updateStatus = async (
        contactId,
        status
    ) => {
        try {
            await contactService.updateStatus(
                contactId,
                status
            );

            setContacts((prev) =>
                prev.map((contact) =>
                    contact.id === contactId
                        ? { ...contact, status }
                        : contact
                )
            );

            toast.success(
                "Cập nhật trạng thái thành công"
            );
        } catch (error) {
            console.error(error);
            toast.error(
                "Lỗi khi cập nhật trạng thái"
            );
        }
    };

    const handleFilterChange = (e) => {
        const { name, value } = e.target;

        setFilters((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const applyFilters = () => {
        setPage(1);
        fetchContacts();
    };

    return {
        contacts,
        loading,

        page,
        totalPages,

        filters,

        setPage,

        handleFilterChange,
        applyFilters,

        updateStatus,
    };
};